/* Cânon Nissi — WhatsApp Modal (carrinho misto) + Fluxo ENCOMENDAR pós-refresh (v6)
   Objetivo: 1 único refresh; adicionar item somente DEPOIS do refresh; zero duplicidade.
*/
(function(){
  if(window.__CN_ENCO_V6_BOOTED){ return; }
  window.__CN_ENCO_V6_BOOTED = true;

  var PDP_ONLY = /\/products\//.test(location.pathname);
  if(!PDP_ONLY) return;

  var INTENT_KEY = "cn_encomendar_intent_v6"; // {id, qty, ts, step}
  var INTENT_TTL = 120000; // 2 min

  // Produtos com a tag "Matricula" têm fluxo próprio (cn-matricula.js).
  // Nessas PDPs o modal de encomenda não deve disparar — a matrícula assume
  // a interceção dos botões de compra e a adição ao carrinho.
  function cnMatriculaActive(){ return !!(window.CN_MATRICULA && window.CN_MATRICULA.active); }

  // ========== utils ==========
  function q(s,c){ return (c||document).querySelector(s); }
  function qa(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); }
  function now(){ return Date.now(); }
  function saveIntent(o){ try{ sessionStorage.setItem(INTENT_KEY, JSON.stringify(o)); }catch(e){} }
  function readIntent(){ try{ var v=sessionStorage.getItem(INTENT_KEY); return v?JSON.parse(v):null; }catch(e){ return null; } }
  function clearIntent(){ try{ sessionStorage.removeItem(INTENT_KEY); }catch(e){} }
  function fetchJSON(u){ return fetch(u,{credentials:'same-origin'}).then(function(r){ return r.json(); }); }
  function getCartJSON(){ return fetchJSON('/cart.js'); }

  // Bloqueio temporário de /cart/add.js enquanto modal estiver aberto
  window.__CN_BLOCK_CART_ADD = false;
  if(!window.__cn_block_patch){
    window.__cn_block_patch = true;
    var _fetch = window.fetch;
    window.fetch = function(resource, init){
      try{
        var url = (typeof resource === 'string') ? resource : (resource && resource.url) || '';
        if(window.__CN_BLOCK_CART_ADD && /\/cart\/add(\.js)?/i.test(url)){
          return Promise.resolve(new Response('{"status":"blocked"}', {status:200, headers:{'Content-Type':'application/json'}}));
        }
      }catch(e){}
      var ret = _fetch.apply(this, arguments);
      try{
        var url = (typeof resource === 'string') ? resource : (resource && resource.url) || '';
        if(/\/cart\/add(\.js)?/i.test(url)){
          ret = ret.then(function(resp){
            // If we set the force flag before add, suppress drawer immediately after success
            if(window.__CN_FORCE_WHATS_AFTER_ADD){
              setTimeout(function(){ try{ suppressCartDrawer(); }catch(e){} }, 30);
            }

            setTimeout(function(){
              try{
                var it = JSON.parse(sessionStorage.getItem('cn_add_disponivel_intent_v1')||'null');
                if(it && Date.now() - (it.ts||0) < 120000){
                  // After add finishes, check if cart is mixed; if so, open WhatsApp
                  getCartJSON().then(deriveCartTags).then(function(res){
                    if(res.isMixed || window.__CN_FORCE_WHATS_AFTER_ADD){ suppressCartDrawer(); openWhats(res.items); }
                  }).finally(function(){ try{ sessionStorage.removeItem('cn_add_disponivel_intent_v1'); }catch(e){} });
                }
              }catch(e){}
            }, 150);
            return resp;
          });
        }
      }catch(e){}
      return ret; };
    var X = window.XMLHttpRequest;
    function P(){ var x=new X(), o=x.open, s=x.send, tgt=''; x.open=function(m,u){ tgt=u||''; return o.apply(x,arguments); };
      x.send=function(b){ try{ if(window.__CN_BLOCK_CART_ADD && /\/cart\/add(\.js)?/i.test(tgt)){ setTimeout(function(){ try{x.status=200;}catch(e){}; try{x.onreadystatechange&&x.onreadystatechange();}catch(e){}; try{x.onload&&x.onload();}catch(e){}; },0); return; } }catch(e){}; return s.apply(x,arguments); };
      return x; }
    window.XMLHttpRequest = P;
  }
  function getVariantQty(){
    var form = document.querySelector('form[action*="/cart/add"]') || document.querySelector('form');
    var idEl = (form && (form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]'))) || document.querySelector('input[name="id"]');
    var qtyEl= (form && form.querySelector('[name="quantity"]')) || document.querySelector('[name="quantity"]');
    var id  = idEl ? (idEl.value || idEl.getAttribute('value')) : null;
    var qty = qtyEl ? parseInt(qtyEl.value || qtyEl.getAttribute('value') || '1',10) : 1;
    return {id:id, qty:isNaN(qty)?1:qty};
  }
  function extractHandle(url){
    try{
      var path=(url||'').split('?')[0], parts=path.split('/').filter(Boolean), i=parts.indexOf('products');
      if(i>=0 && parts[i+1]) return parts[i+1];
      return parts[parts.length-1]||'';
    }catch(e){ return ''; }
  }
  function getTagsByHandle(h){
    if(!h) return Promise.resolve([]);
    return fetchJSON('/products/'+h+'.js').then(function(p){ return (p&&p.tags)?p.tags:[]; }).catch(function(){ return []; });
  }
  var CN_CART_HAS_ENCO = false;
  function deriveCartTags(cart){
    var items=cart.items||[];
    return Promise.all(items.map(function(it){
      var handle = it.handle || extractHandle(it.url||'');
      return getTagsByHandle(handle).then(function(tags){ return {
        title: it.title,
        product_title: it.product_title,
        variant_title: it.variant_title,
        sku: it.sku,
        price: it.price,
        final_line_price: it.final_line_price,
        quantity: it.quantity,
        tags: tags,
        handle: handle
      }; });
    })).then(function(arr){
      var hasD=false, hasE=false;
      arr.forEach(function(it){
        var t=(it.tags||[]).map(function(s){ return (s||'').toLowerCase().trim(); });
        if(t.includes('disponivel')||t.includes('disponível')) hasD=true;
        if(t.includes('encomendar')||t.includes('pré-venda')||t.includes('pre-venda')||t.includes('preorder')) hasE=true;
      });
      CN_CART_HAS_ENCO = hasE; return {items:arr, isMixed:(hasD && hasE)};
    });
  }

  // ========== WhatsApp modal ==========
  function suppressCartDrawer(){
    var sels = ['#CartDrawer','.cart-drawer','.drawer--cart','.ajaxcart','.ajaxcart__wrapper','.js-drawer-open-cart','.header-cart','[data-cart-drawer]'];
    sels.forEach(function(sel){
      var el = document.querySelector(sel);
      if(el){
        try{
          el.style.display='none';
          el.classList.remove('open','is-open','active','shown','show');
          el.setAttribute('aria-hidden','true');
        }catch(e){}
      }
    });
  }
  function supressPreorder(){
    ['#preorder-modal','[data-preorder-modal]','#preorderModal','.preorder-modal'].forEach(function(sel){
      var el=q(sel); if(el){ el.style.display='none'; el.classList.remove('open','is-active','active','show'); el.setAttribute('aria-hidden','true'); }
    });
  }
  // Global handler to guarantee single hard refresh from the "Continuar comprando" button
  window.__CNW_CONTINUE_LOCK = false;
  window.cnw_continue_shopping = function(ev){
    try{ if(ev){ ev.preventDefault(); ev.stopImmediatePropagation(); ev.stopPropagation(); } }catch(e){}
    if(window.__CNW_CONTINUE_LOCK) return;
    window.__CNW_CONTINUE_LOCK = true;
    try{
      var ov=document.querySelector('#cn-whatsapp-mixed-overlay');
      if(ov){ ov.classList.remove('cnw-open'); document.body.classList.remove('cnw-modal-open'); document.documentElement.classList.remove('cnw-modal-open'); }
    }catch(e){}
    // Reset intent flags
    try{ sessionStorage.removeItem('cn_add_disponivel_intent_v1'); }catch(e){}
    try{ sessionStorage.removeItem('cn_encomendar_intent_v6'); }catch(e){}
    try{ window.__CN_FORCE_WHATS_AFTER_ADD=false; }catch(e){}
    // Force a single hard reload
    try{ cnwHardReloadOnce(); }catch(e){ try{ location.reload(); }catch(_){ } }
  };
  // Delegated listener (resilient to DOM rerenders)
  document.addEventListener('click', function(e){
    var el=e.target;
    for(var i=0;i<3 && el;i++, el=el.parentElement){
      if(el && (el.id==='cnw-continue' || el.hasAttribute && el.hasAttribute('data-cnw-continue'))){
        return window.cnw_continue_shopping(e);
      }
    }
  }, true);

  function fmtEurWA(c){ if(c == null || isNaN(c)) return ''; return '€' + (Number(c)/100).toFixed(2).replace('.', ','); }

  // Linhas detalhadas, iguais às do formulário de encomenda: variante, SKU,
  // quantidade, preço unitário e subtotal. Antes esta função só mandava
  // "• TÍTULO xN", por isso a mensagem do carrinho misto saía sem SKU.
  function linhasWA(items){
    var totalCents = 0;
    var linhas = (items||[]).map(function(it){
      var nome = it.product_title || it.title || 'Produto';
      var variante = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      var qty = it.quantity || 1;
      var unit = fmtEurWA(it.price);
      var sub  = fmtEurWA(it.final_line_price != null ? it.final_line_price : (it.price||0)*qty);
      if(it.final_line_price != null) totalCents += Number(it.final_line_price);
      else if(it.price != null) totalCents += Number(it.price) * qty;
      var l = '• ' + nome;
      if(variante) l += '\n   - Variante: ' + variante;
      if(it.sku) l += '\n   - SKU: ' + it.sku;
      l += '\n   - Qtd: ' + qty + (unit ? ' × ' + unit : '') + (sub ? ' = ' + sub : '');
      return l;
    }).join('\n');
    return linhas + (totalCents > 0 ? '\nTotal: ' + fmtEurWA(totalCents) : '');
  }

  function buildWhatsHref(items, mode){
    var phone = '351913767399';
    // Uma só codificação no fim: antes o texto fixo vinha pré-codificado e os
    // títulos entravam em cru, o que partia o link em nomes com & ou #.
    var msg = mode === 'mixed'
      ? 'Olá! Adicionei estes produtos ao carrinho:\n' + linhasWA(items) +
        '\n\nHá itens com prazos diferentes no carrinho. Pode ajudar-me a finalizar corretamente?'
      : 'Olá! Gostaria de encomendar estes produtos:\n' + linhasWA(items) +
        '\n\nEstes itens são feitos por encomenda e podem ter prazo maior. Pode ajudar-me a finalizar?';
    return 'https://wa.me/' + phone + '?text=' + encodeURIComponent(msg);
  }

  function openWhats(items){ window.__CN_BLOCK_CART_ADD = true;
    var ov=q('#cn-whatsapp-mixed-overlay'); if(!ov) return;
    try { if(ov.parentNode !== document.body) document.body.appendChild(ov); } catch(e){}
    var box=q('#cnw-items');
    if(box){
      var ul=document.createElement('ul');
      (items||[]).forEach(function(it){ var li=document.createElement('li'); li.textContent=(it.title||'Produto')+' x'+(it.quantity||1); ul.appendChild(li); });
      box.innerHTML=''; box.appendChild(ul);
    }
    var wa=q('#cnw-whatsapp');
    if(wa){ wa.href = buildWhatsHref(items, 'mixed'); }
    function close(){ ov.classList.remove('cnw-open'); document.body.classList.remove('cnw-modal-open'); document.documentElement.classList.remove('cnw-modal-open'); window.__CN_BLOCK_CART_ADD=false; }
    var closeBtn=q('.cnw-close'); if(closeBtn){ closeBtn.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); close(); }, {once:true, capture:true}); }
    var cont=q('#cnw-continue');
    ov.addEventListener('click', function(e){ if(e.target===ov) close(); }, {capture:true});
    supressPreorder();
    ov.classList.add('cnw-open'); document.body.classList.add('cnw-modal-open'); document.documentElement.classList.add('cnw-modal-open');
  }

  // ========== Modal nativo centralizado + "Continuar" sem refresh ==========
  function openEncomendar(items){
    // Produto de matrícula: o modal próprio já trata deste fluxo.
    if(cnMatriculaActive()) return false;
    // Abrir modal WhatsApp de encomenda
    var ov = q('#cn-encomendar-overlay');
    if(!ov){ return false; }
    // Garante que o overlay esteja no <body> (evita ficar descentralizado quando
    // há um ancestral com transform/filter/perspective, que quebra position:fixed)
    try { if(ov.parentNode !== document.body) document.body.appendChild(ov); } catch(e){}
    // Ativa bloqueio de add enquanto o modal estiver aberto
    window.__CN_BLOCK_CART_ADD = true;

    var currentItems = items || [];

    // Lista itens
    var box = q('#cne-items', ov);
    if(box){
      var ul=document.createElement('ul');
      currentItems.forEach(function(it){ var li=document.createElement('li'); li.textContent=(it.title||'Produto')+' x'+(it.quantity||1); ul.appendChild(li); });
      box.innerHTML=''; box.appendChild(ul);
    }

    // Referências do form/estado inicial
    var form     = q('#cne-form', ov);
    var introPs  = ov.querySelectorAll('.cnw-body > p');
    var itemsBox = q('#cne-items', ov);
    var footer   = ov.querySelector('.cnw-footer');
    var btnWA    = q('#cne-whatsapp', ov);
    var btnBack  = q('#cne-form-back', ov);
    var titleEl  = q('#cne-title', ov);

    function showInitial(){
      if(form) form.hidden = true;
      introPs.forEach(function(p){ p.style.display = ''; });
      if(itemsBox) itemsBox.style.display = '';
      if(footer) footer.style.display = '';
      if(titleEl) titleEl.textContent = 'Produto temporariamente esgotado!';
    }
    function showForm(){
      introPs.forEach(function(p){ p.style.display = 'none'; });
      if(itemsBox) itemsBox.style.display = 'none';
      if(footer) footer.style.display = 'none';
      if(titleEl) titleEl.textContent = 'Dados para a encomenda';
      if(form) form.hidden = false;
    }
    showInitial();
    if(form) form.reset();

    // Botão "FALAR NO WHATSAPP" agora abre o formulário
    if(btnWA){
      btnWA.onclick = function(ev){ ev.preventDefault(); ev.stopPropagation(); showForm(); };
    }
    if(btnBack){
      btnBack.onclick = function(ev){ ev.preventDefault(); ev.stopPropagation(); showInitial(); };
    }

    // Submit do formulário → monta mensagem com itens + dados e abre WhatsApp
    if(form){
      form.onsubmit = function(ev){
        ev.preventDefault();
        if(typeof form.checkValidity === 'function' && !form.checkValidity()){
          if(typeof form.reportValidity === 'function') form.reportValidity();
          return false;
        }
        var fd = new FormData(form);
        function v(n){ return String(fd.get(n) || '').trim(); }
        function fmtEur(c){ if(c == null || isNaN(c)) return ''; return '€' + (Number(c)/100).toFixed(2).replace('.', ','); }
        var totalCents = 0;
        var lines = currentItems.map(function(it){
          var name = it.product_title || it.title || 'Produto';
          var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
          var qty = it.quantity || 1;
          var unit = fmtEur(it.price);
          var sub  = fmtEur(it.final_line_price != null ? it.final_line_price : (it.price||0)*qty);
          if(it.final_line_price != null) totalCents += Number(it.final_line_price);
          else if(it.price != null) totalCents += Number(it.price) * qty;
          var l = '• ' + name;
          if(variant) l += '\n   - Variante: ' + variant;
          if(it.sku) l += '\n   - SKU: ' + it.sku;
          l += '\n   - Qtd: ' + qty + (unit ? ' × ' + unit : '') + (sub ? ' = ' + sub : '');
          return l;
        }).join('\n');
        var totalLine = totalCents > 0 ? ('\nTotal: ' + fmtEur(totalCents)) : '';
        var msg =
          'Olá! Gostaria de encomendar:\n' + lines + totalLine + '\n\n' +
          'Dados para encomenda:\n' +
          'Nome: ' + v('nome') + '\n' +
          'Telefone: ' + v('telefone') + '\n' +
          'E-mail: ' + v('email') + '\n' +
          'NIF: ' + v('nif') + '\n' +
          'Morada: ' + v('morada') + '\n' +
          'Código Postal: ' + v('cp') + '\n' +
          'Freguesia: ' + v('freguesia') + '\n' +
          'Distrito: ' + v('distrito');
        var href = 'https://wa.me/351913767399?text=' + encodeURIComponent(msg);
        try { window.open(href, '_blank', 'noopener'); }
        catch(e){ window.location.href = href; }
        close();
        return false;
      };
    }

    function close(){
      ov.classList.remove('cnw-open');
      document.body.classList.remove('cnw-modal-open'); document.documentElement.classList.remove('cnw-modal-open');
      window.__CN_BLOCK_CART_ADD = false; // liberar add novamente
      showInitial();
      if(form) form.reset();
    }
    var btnClose = q('.cne-close', ov);
    if(btnClose){ btnClose.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); close(); }, {once:true, capture:true}); }
    var cont = q('#cne-continue', ov);
    if(cont){ cont.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); close(); }, {once:true, capture:true}); }
    ov.addEventListener('click', function(e){ if(e.target===ov){ close(); } }, {capture:true});

    ov.classList.add('cnw-open'); document.body.classList.add('cnw-modal-open'); document.documentElement.classList.add('cnw-modal-open');
    return true;
  }

  // ========== Pós-refresh ==========
  var __processing = false;
  function afterRefresh(){
    if(__processing) return;
    var it=readIntent();
    if(!it) return;
    if(now()-it.ts>INTENT_TTL){ clearIntent(); return; }
    __processing = true;

    // Passo A: se ainda não adicionou, adiciona 1x
    if(it.step!=='added'){
      it.step='adding'; saveIntent(it);
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id: it.id, quantity: it.qty||1 }) })
        .catch(function(){})
        .finally(function(){ it.step='added'; saveIntent(it); try{ sessionStorage.setItem('cn_last_preorder', JSON.stringify({id: it.id, qty: it.qty||1, ts: Date.now()})); }catch(e){} decide(); });
      return;
    }
    decide();

    function decide(){
      getCartJSON().then(deriveCartTags).then(function(res){
        if(res.isMixed || window.__CN_FORCE_WHATS_AFTER_ADD){ suppressCartDrawer(); openWhats(res.items); }
        else { openEncomendar(res.items); }
      }).finally(function(){ clearIntent(); __processing=false; });
    }
  }


  // Interceptar "Adicionar ao carrinho" quando já existe ENCOMENDAR no carrinho (PDP)
  function interceptAvailableAdd(){
    var addSelectors = [
      'button[name="add"]',
      '.product-form button[type="submit"]',
      'button.add-to-cart',
      'button[data-add-to-cart]',
      '#AddToCart,#add-to-cart'
    ];

    // Click: se carrinho já tem encomendar, bloqueia e faz add manual + WhatsApp
    document.addEventListener('click', function(ev){
      if(cnMatriculaActive()) return;
      var el = ev.target, matched = null;
      for(var i=0;i<4 && el;i++, el=el.parentElement){
        for(var s of addSelectors){
          if(el.matches && el.matches(s)){ matched = el; break; }
        }
        if(matched) break;
      }
      if(!matched) return;

      var text = (matched.textContent||'').trim().toLowerCase();
      // ignorar botões de ENCOMENDAR
      if(text.includes('encomendar') || matched.matches('#preorder-button, #encomendar-agora, .button-encomendar, button[data-encomendar], button[name=\"encomendar\"], button.cn-preorder')){
        return;
      }
      if(!CN_CART_HAS_ENCO) return;

      ev.preventDefault(); ev.stopImmediatePropagation(); ev.stopPropagation();
      // desativa para evitar duplo clique
      if(matched.disabled !== undefined){ matched.disabled = true; matched.setAttribute('aria-busy','true'); }
      // bloquear drawer temporariamente
      window.__CN_FORCE_WHATS_AFTER_ADD = true;
      try{ suppressCartDrawer(); }catch(e){}

      var vk = getVariantQty();
      if(!vk.id){ window.__CN_FORCE_WHATS_AFTER_ADD=false; return; }

      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ id: vk.id, quantity: vk.qty||1 })
      })
      .then(function(){ return getCartJSON(); })
      .then(function(cart){ return deriveCartTags(cart); })
      .then(function(res){
        if(res.isMixed || CN_CART_HAS_ENCO){
          suppressCartDrawer();
          openWhats(res.items);
        }
      })
      .finally(function(){
        window.__CN_FORCE_WHATS_AFTER_ADD = false;
        if(matched.disabled !== undefined){ matched.disabled = false; matched.removeAttribute('aria-busy'); }
      });
    }, true);

    // Submit: redundância para temas que submetem o form em vez do click
    document.addEventListener('submit', function(ev){
      if(cnMatriculaActive()) return;
      if(!CN_CART_HAS_ENCO) return;
      var form = ev.target;
      var action = (form.getAttribute('action')||'').toLowerCase();
      if(action.indexOf('/cart/add') === -1 && !form.querySelector('input[name=\"id\"]')) return;

      // tenta identificar se o botão é de encomendar; se não conseguir, seguimos como disponível
      var btn = form.querySelector('button[type=\"submit\"], button[name=\"add\"], .add-to-cart');
      var isEncoBtn = btn && ((btn.textContent||'').trim().toLowerCase().includes('encomendar') || btn.matches('#preorder-button, #encomendar-agora, .button-encomendar, button[data-encomendar], button[name=\"encomendar\"], button.cn-preorder'));
      if(isEncoBtn) return;

      ev.preventDefault(); ev.stopImmediatePropagation();

      window.__CN_FORCE_WHATS_AFTER_ADD = true;
      try{ suppressCartDrawer(); }catch(e){}

      var idEl = form.querySelector('input[name=\"id\"], select[name=\"id\"]');
      var qtyEl = form.querySelector('[name=\"quantity\"]');
      var id = idEl ? (idEl.value || idEl.getAttribute('value')) : null;
      var qty = qtyEl ? parseInt(qtyEl.value || qtyEl.getAttribute('value') || '1', 10) : 1;
      if(!id){ window.__CN_FORCE_WHATS_AFTER_ADD=false; return; }

      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ id: id, quantity: isNaN(qty)?1:qty })
      })
      .then(function(){ return getCartJSON(); })
      .then(function(cart){ return deriveCartTags(cart); })
      .then(function(res){
        if(res.isMixed || CN_CART_HAS_ENCO){
          suppressCartDrawer();
          openWhats(res.items);
        }
      })
      .finally(function(){ window.__CN_FORCE_WHATS_AFTER_ADD = false; });
    }, true);
  }

  // ========== Clique em ENCOMENDAR (apenas UMA navegação) ==========
  function enhance(){
    var sels=['#preorder-button','#encomendar-agora','.button-encomendar','button[data-encomendar]','button[name="encomendar"]','button.cn-preorder'];
    document.addEventListener('pointerdown', function(e){
      var el=e.target;
      var sels=['#preorder-button','#encomendar-agora','.button-encomendar','button[data-encomendar]','button[name="encomendar"]','button.cn-preorder'];
      for(var i=0;i<4 && el;i++, el=el.parentElement){
        for(var s of sels){
          if(el.matches && el.matches(s)){
            var t=(el.textContent||'').trim().toLowerCase();
            if(t.includes('encomendar')){
              // Pré-sinaliza intenção para bloquear submit nativo em temas que disparam no mousedown
              var vk=(function(){
                var form = document.querySelector('form[action*="/cart/add"]') || document.querySelector('form');
                var idEl = (form && (form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]'))) || document.querySelector('input[name="id"]');
                var qtyEl= (form && form.querySelector('[name="quantity"]')) || document.querySelector('[name="quantity"]');
                var id  = idEl ? (idEl.value || idEl.getAttribute('value')) : null;
                var qty = qtyEl ? parseInt(qtyEl.value || qtyEl.getAttribute('value') || '1',10) : 1;
                return {id:id, qty:isNaN(qty)?1:qty};
              })();
              // intent legado desabilitado — fluxo agora é direto (sem refresh)
              return;
            }
          }
        }
      }
    }, true);

    document.addEventListener('click', function(e){
      if(cnMatriculaActive()) return;
      var el=e.target;
      for(var i=0;i<4 && el; i++, el=el.parentElement){
        for(var s of sels){
          if(el.matches && el.matches(s)){
            var t=(el.textContent||'').trim().toLowerCase();
            if(t.includes('encomendar')){
              e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
              if(el.disabled) return;
              el.disabled=true; el.setAttribute('aria-busy','true');
              var vk=getVariantQty(); if(!vk.id){ el.disabled=false; el.removeAttribute('aria-busy'); return; }
              // Fluxo direto (sem refresh): add + abre modal novo
              try{ sessionStorage.removeItem('cn_encomendar_intent_v6'); }catch(_){}
              try{ suppressCartDrawer(); }catch(_){}
              fetch('/cart/add.js', {
                method:'POST',
                headers:{'Content-Type':'application/json','Accept':'application/json'},
                body: JSON.stringify({ id: vk.id, quantity: vk.qty||1 })
              })
              .then(function(){ return getCartJSON(); })
              .then(deriveCartTags)
              .then(function(res){
                try{ suppressCartDrawer(); }catch(_){}
                openEncomendar(res.items);
              })
              .catch(function(){})
              .finally(function(){
                el.disabled=false; el.removeAttribute('aria-busy');
              });
              return;
            }
          }
        }
      }
    }, true);
  }

  // Interceptar submit de forms /cart/add quando houver intenção ativa (evita adição antes do refresh)
  document.addEventListener('submit', function(ev){
    if(cnMatriculaActive()) return;
    var it = (function(){ try{ return JSON.parse(sessionStorage.getItem('cn_encomendar_intent_v6')||'null'); }catch(e){ return null; } })();
    if(!it) return;
    var form = ev.target;
    var action = (form.getAttribute('action')||'').toLowerCase();
    if(action.indexOf('/cart/add') !== -1 || form.querySelector('input[name="id"]')){
      ev.preventDefault(); ev.stopImmediatePropagation();
      // Garante apenas 1 refresh
      var url = new URL(window.location.href);
      if(!url.searchParams.get('cnr')){ url.searchParams.set('cnr','1'); }
      window.location.replace(url.toString());
    }
  }, true);

  interceptAvailableAdd();

  // ====== Exibir aviso "Produtos Encomendados" apenas quando botão ENCOMENDAR estiver visível ======
  function cnIsVisible(el){
    if(!el) return false;
    var s = window.getComputedStyle ? getComputedStyle(el) : el.style;
    return el.offsetParent !== null && s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0';
  }
  function cnTogglePreorderNotice(){
    try{
      var preorderBtn = document.querySelector('#preorder-button');
      var showNotice = !!(preorderBtn && cnIsVisible(preorderBtn) && !preorderBtn.disabled);

      var previews = Array.prototype.slice.call(document.querySelectorAll('pickup-availability-preview'));
      previews.forEach(function(p){
        var strong = p.querySelector('.pickup-availability-info strong');
        var isPreorderBlock = strong && /produtos\s+encomendados/i.test((strong.textContent||'').trim());
        if(isPreorderBlock){
          p.style.display = showNotice ? '' : 'none';
        }
      });
    }catch(e){}
  }

  // Inicializa e observa mudanças (variação, trocas de DOM, etc.)
  try{
    document.addEventListener('DOMContentLoaded', cnTogglePreorderNotice);
    // Dispara logo no boot também
    cnTogglePreorderNotice();

    var mo = new MutationObserver(function(m){
      // Reavalia em qualquer mudança relevante
      cnTogglePreorderNotice();
    });
    mo.observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['style','class','disabled','hidden']});

    // Reage a mudanças de selects/inputs da PDP
    document.addEventListener('change', function(e){
      if(e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')){
        cnTogglePreorderNotice();
      }
    }, true);
  }catch(e){}

  enhance();
  /*INIT_CN_CART_FLAG*/
  try{ getCartJSON().then(deriveCartTags).catch(function(){}); }catch(e){}

  if(document.readyState==='complete' || document.readyState==='interactive'){ afterRefresh(); }
  else { document.addEventListener('DOMContentLoaded', afterRefresh); }

})();
